module.exports = __webpack_public_path__ + "cecaf729c128f84a8d3723793936770c.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/mug-white-blank.png
// module id = 789
// module chunks = 0